import { render, staticRenderFns } from "./HeaderSearch.vue?vue&type=template&id=25f260c6&"
import script from "./HeaderSearch.vue?vue&type=script&lang=js&"
export * from "./HeaderSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25f260c6')) {
      api.createRecord('25f260c6', component.options)
    } else {
      api.reload('25f260c6', component.options)
    }
    module.hot.accept("./HeaderSearch.vue?vue&type=template&id=25f260c6&", function () {
      api.rerender('25f260c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/headers/shared/HeaderSearch.vue"
export default component.exports